// -----------------------------------------------------------------------------
// VeeValidate config
// -----------------------------------------------------------------------------
// Docs: https://baianat.github.io/vee-validate/configuration.html
// -----------------------------------------------------------------------------

export const VeeValidateConfig = {
  aria: false,
  delay: 300,
  dictionary: {
    ru: {
      // Translation of messages
      messages: {
        required: 'Это поле обязательно',
        email: 'Введите корректный email',
        cyr_alpha: 'Допускается только кириллица'
      },

      // Translation of names
      attributes: {
        phone: 'телефон',
        email: 'почта'
      },

      // Custom messages
      custom: {
        name: {
          min: 'Необходимо ввести 2 или больше символов'
        },
        surname: {
          min: 'Необходимо ввести 2 или больше символов'
        },
        patronymic: {
          min: 'Необходимо ввести 2 или больше символов'
        },
        phone: {
          min: 'Некорректное значение',
          max: 'Некорректное значение'
        },
        sms_code: {
          length: (n, v) => `Код должен состоять из ${v} цифр`,
          required: 'Введите проверочный код'
        },
        password: {
          min: (n, v) => `Длина пароля от ${v} символов`
        }
      }
    }
  },
  locale: 'ru'
}

export const cyrAlpha = {
  getMessage: field => 'Поле ' + field + ' не прошло валидацию',
  validate: value => {
    // Check if empty value => true
    if (value.length > 0) {
      const pattern = /^[- а-яА-ЯёЁ]+$/
      return pattern.test(value)
    } else {
      return true
    }
  }
}
